import {Helmet} from 'react-helmet-async';
// @mui
import {
    Card,
    Stack,
    Container,
    Typography,
    TableContainer,
    CardContent,
    Button,
    CircularProgress,
    Box,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Divider, CardHeader, IconButton, FormControlLabel, Radio, RadioGroup, Modal,
} from '@mui/material';

import {useNavigate, useParams} from 'react-router-dom';

// components
import Scrollbar from '../components/scrollbar';
// sections
import {StepByStepTable} from "../sections/@dashboard/attestations";
import {GeneralLayout} from "../layouts/GeneralLayout";
import Label from "../components/label";
import TextField from "@mui/material/TextField";
import {useEffect, useState} from "react";
import {useGetNextAttestationNumberQuery, usePostCreateAttestationMutation} from "../store/attestation/attestationApi";
import PageTitle from "../components/PageTitle";
import {Alert} from "@mui/lab";
import MainLayout from "./main";
import {
    AddBoxOutlined,
    ArrowDownward,
    ArrowRight,
    ArrowUpward, Help,
    PlusOne,
    SaveAltOutlined,
    SaveAs,
    Warning, WarningAmber,
    WarningOutlined
} from "@mui/icons-material";
import {
    useGetDisciplineGroupJournalBasicsQuery,
} from "../store/journal/journalApi";
import copyObject from "../utils/copyObject";
import AddIcon from "@mui/icons-material/Add";
import CheckIcon from "@mui/icons-material/Check";
import MenuItem from "@mui/material/MenuItem";
import DeleteIcon from "@mui/icons-material/Delete";
import PrintIcon from "@mui/icons-material/Print";
import {
    useGetGrsParamsQuery,
    useGetTechMapQuery,
    useRemoveTechMapMutation,
    useSaveTechMapMutation
} from "../store/grc/grcApi";
import {useGetThemesListQuery} from "../store/themeplan/themePlanApi";

export default function GradeRatingSystemPage() {
    const {courseId, disciplineId, virtualGroupId} = useParams();
    const examTasksMaxPoints = 36;
    const isAdmin = localStorage.getItem('roles').split(',').find((item) => item.toLowerCase() === 'attnewadmin') !== undefined;
    const navigate = useNavigate();
    const [isSaving, setIsSaving] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isRemovingTechMap, setIsRemovingTechMap] = useState(false);
    const [printIsLoading, setPrintIsLoading] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const [saveDataRequest] = useSaveTechMapMutation();
    const {data: themesData} = useGetThemesListQuery({courseId, disciplineId, virtualGroupId});
    const {data: techMapData, isLoading: isTechMapLoading} = useGetTechMapQuery({courseId, disciplineId, virtualGroupId});
    const {data: disciplineData} = useGetDisciplineGroupJournalBasicsQuery({courseId, disciplineId});
    const [copyOfTechMap, setCopyOfTechMap] = useState(null);
    const [copyOfThemes, setCopyOfThemes] = useState([]);
    const [canEdit, setCanEdit] = useState(false);
    const delimiterStyle = {'borderRight': '0.5px solid black'};
    const totalStyle = {'background': '#caccd1', "color": 'black', 'fontWeight': 'bold'};
    const [secondSemesterPosition, setSecondSemesterPosition] = useState(0);
    const [disciplineRequirements, setDisciplineRequirements] = useState([]);
    const [range, setRange] = useState({
        grade5To: 100,
        grade5From: 86,
        grade4To: 85,
        grade4From: 70,
        grade3To: 69,
        grade3From: 50,
        grade2To: 49,
        grade2From: 0
    });
    const [standardLectureHoursFrom, setStandardLectureHoursFrom] = useState(0);
    const [standardLectureHoursTo, setStandardLectureHoursTo] = useState(0);
    const [standardAuditoriumHoursFrom, setStandardAuditoriumHoursFrom] = useState(0);
    const [standardAuditoriumHoursTo, setStandardAuditoriumHoursTo] = useState(0);
    const [disciplineLectureHoursMaximum, setDisciplineLectureHoursMaximum] = useState(0);
    const [disciplineAuditoriumHoursMaximum, setDisciplineAuditoriumHoursMaximum] = useState(0);
    const [initDone, setInitDone] = useState(false);
    const [redrawBeforeInitDone, setRedrawBeforeInitDone] = useState(false);
    const [openGradeConversionModal, setOpenGradeConversionModal] = useState(false);
    const [openSecondSemesterPartGradeConversionModal, setOpenSecondSemesterPartGradeConversionModal] = useState(false);
    const [selectedRequirement, setSelectedRequirement] = useState(null);
    const [attestationRange, setAttestationRange] = useState({
        attestationConversionGrade5From: 0,
        attestationConversionGrade4From: 0,
        attestationConversionGrade3From: 0,
        attestationConversionGrade2From: 0,
        attestationConversionGrade5To: 0,
        attestationConversionGrade4To: 0,
        attestationConversionGrade3To: 0,
        attestationConversionGrade2To: 0,
    });
    const [examTasks, setExamTasks] = useState([]);
    const [attendanceDistribution, setAttendanceDistribution] = useState(false);
    const [distributionData, setDistributionData] = useState({
        hours: 0,
        points: 0
    });
    const [removeTechMapRequest] = useRemoveTechMapMutation();
    const {data: grsParams} = useGetGrsParamsQuery();
    
    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        backgroundColor: '#FAFAFA',
        border: '1px solid black',
        borderRadius: '10px',
        boxShadow: 24,
        p: 4,
        padding: '10px',
    };
    const examTaskTypes = [
        {id: 1, title: 'Теоретический вопрос'},
        {id: 2, title: 'Задание'}
    ];
    const [trickRenderCounter, setTrickRenderCounter] = useState(0);

    useEffect(() => {
        if (trickRenderCounter > 10)
            return;
        
        if (initDone)
            return;

        setTrickRenderCounter(trickRenderCounter + 1);
        if (copyOfThemes.length === 0) {
            if (themesData !== undefined && themesData) {
                setCopyOfThemes(copyObject(themesData.data));
            }
        }

        if (techMapData !== undefined && techMapData) {
            setCopyOfTechMap(techMapData);
            // range.grade5From = techMapData?.data?.conversionRangeGrade5From ?? 0;
            // range.grade5To = techMapData?.data?.conversionRangeGrade5To ?? 0;
            // range.grade4From = techMapData?.data?.conversionRangeGrade4From ?? 0;
            // range.grade4To = techMapData?.data?.conversionRangeGrade4To ?? 0;
            // range.grade3From = techMapData?.data?.conversionRangeGrade3From ?? 0;
            // range.grade3To = techMapData?.data?.conversionRangeGrade3To ?? 0;
            // range.grade2From = techMapData?.data?.conversionRangeGrade2From ?? 0;
            // range.grade2To = techMapData?.data?.conversionRangeGrade2To ?? 0;
            attestationRange.attestationConversionGrade5From = techMapData?.data?.attestationConversionGrade5From ?? 0;
            attestationRange.attestationConversionGrade4From = techMapData?.data?.attestationConversionGrade4From ?? 0;
            attestationRange.attestationConversionGrade3From = techMapData?.data?.attestationConversionGrade3From ?? 0;
            attestationRange.attestationConversionGrade2From = techMapData?.data?.attestationConversionGrade2From ?? 0;
            attestationRange.attestationConversionGrade5To = techMapData?.data?.attestationConversionGrade5To ?? 0;
            attestationRange.attestationConversionGrade4To = techMapData?.data?.attestationConversionGrade4To ?? 0;
            attestationRange.attestationConversionGrade3To = techMapData?.data?.attestationConversionGrade3To ?? 0;
            attestationRange.attestationConversionGrade2To = techMapData?.data?.attestationConversionGrade2To ?? 0;
            setDisciplineLectureHoursMaximum(techMapData?.data?.disciplineLectureHoursMaximum ?? 0);
            setDisciplineAuditoriumHoursMaximum(techMapData?.data?.disciplineAuditoriumHoursMaximum ?? 0);
            setStandardLectureHoursFrom(techMapData?.data?.standardLectureHoursFrom ?? 0);
            setStandardLectureHoursTo(techMapData?.data?.standardLectureHoursTo ?? 0);
            setStandardAuditoriumHoursFrom(techMapData?.data?.standardAuditoriumHoursFrom ?? 0);
            setStandardAuditoriumHoursTo(techMapData?.data?.standardAuditoriumHoursTo ?? 0);
            setDisciplineRequirements(techMapData?.data?.activities ? copyObject(techMapData?.data?.activities) : []);
            setCanEdit((techMapData?.data?.disciplineTechMapId ?? 0) === 0 || techMapData?.data?.availableForEditing);
            setExamTasks(techMapData?.data?.examTasks ? copyObject(techMapData?.data?.examTasks) : []);

            applyVisualChanges();
        }

        if (copyOfThemes && copyOfThemes?.length > 0 && techMapData?.data && disciplineRequirements) {
            // let secondSemesterIndex = 0;
            // for (let i = 0; i < themesData.data.length; i += 1) {
            //     if (themesData?.data[i].lessonTypes.find(lt => lt.themePlanId === techMapData?.data?.secondSemesterStartsFromThemePlanId) !== undefined) {
            //         secondSemesterIndex = i;
            //         break;
            //     }
            // }
            //
            //
            // console.log('Нашли индекс 2 семестра', secondSemesterIndex);
            
            if (techMapData.data.themesOfFirstPartOfSemester !== null) {
                let stopAllLoops = false;
                for (let i = 0; i < copyOfThemes.length; i += 1) {
                    for (let j = 0; j < copyOfThemes[i].lessonTypes.length; j += 1) {
                        if (techMapData.data.themesOfFirstPartOfSemester.find((item) => copyOfThemes[i].lessonTypes[j].themePlanIds.find((tp) => tp === item) !== undefined) !== undefined) {
                            if (i > secondSemesterPosition) {
                                setSecondSemesterPosition(i > 0 ? i : 0);
                            }
                            stopAllLoops = true;
                            // break;
                        }
                    }
                    
                    if (false && stopAllLoops)
                        break;
                }
            }
            
            // setSecondSemesterPosition(techMapData?.data?.secondSemesterStartsFromOrderNumber ?? 0);

            copyOfThemes.forEach(theme => {
                const themeActivity = techMapData?.data?.themes?.find((item) =>
                    theme.lessonTypes.find(lt =>
                        lt.themePlanIds.find(tpi =>
                            item.lessonTypes.find(tmlt =>
                                tmlt.themePlanIds.find(tmtpi =>
                                    tmtpi === tpi)
                                !== undefined)
                            !== undefined)
                        !== undefined)
                    !== undefined);

                theme.labsGrade = themeActivity?.labsGrade ?? 0;
                theme.lecturesGrade = themeActivity?.lecturesGrade ?? 0;
                theme.seminarsGrade = themeActivity?.seminarsGrade ?? 0;
                theme.labsHours = themeActivity?.labsHours ?? 0;
                theme.lecturesHours = themeActivity?.lecturesHours ?? 0;
                theme.seminarsHours = themeActivity?.seminarsHours ?? 0;
                theme.activities = themeActivity?.activities?.map((act) => {
                    return {
                        points: act.points.toString(), // .toString(),
                        association: disciplineRequirements?.find((dr) => dr.key === act.association.key),
                    }
                }) ?? [];
            });

            if (redrawBeforeInitDone)
                setInitDone(true);

            setRedrawBeforeInitDone(true);
        }
    }, [themesData, techMapData, copyOfThemes, disciplineRequirements, redrawBeforeInitDone]);

    function formatDate(dateObj) {
        return `${dateObj.getFullYear()}-${withZero(dateObj.getMonth() + 1)}-${withZero(dateObj.getDate())}`;
    }

    function applyVisualChanges() {
        setRefresh(!refresh);
    }

    function toDateString(date) {
        if (date === null || date === undefined)
            return '';

        return new Date(date).toLocaleDateString("ru-RU");
    }

    function withZero(num) {
        return num < 10 ? `0${num}` : num;
    }
    
    function disciplineRequirementsFulfilled() {
        if (disciplineRequirements.find(item => !item.points || !item.maxPoints))
            return false;
        
        return disciplineRequirements && disciplineRequirements.length > 0;
    }
    
    function disciplineRequirementsConversionFulfilled() {
        return disciplineRequirements.find(item => 
            item.conversionGrade5
            || item.conversionGrade4
            || item.conversionGrade3
            || item.conversionGrade2
            ) !== undefined;
    }
    
    function attestationGradesAreCorrect() {
        return parseFloat(attestationRange.attestationConversionGrade5From.toString()) > parseFloat(attestationRange.attestationConversionGrade4To.toString())
            && (!parseFloat(attestationRange.attestationConversionGrade4From.toString()) && !parseFloat(attestationRange.attestationConversionGrade3To.toString())
                || parseFloat(attestationRange.attestationConversionGrade4From.toString()) > parseFloat(attestationRange.attestationConversionGrade3To.toString()))
            && (!parseFloat(attestationRange.attestationConversionGrade3From.toString()) && !parseFloat(attestationRange.attestationConversionGrade2To.toString())
                || parseFloat(attestationRange.attestationConversionGrade3From.toString()) > parseFloat(attestationRange.attestationConversionGrade2To.toString()))
            && parseFloat(attestationRange.attestationConversionGrade5To.toString()) >= parseFloat(attestationRange.attestationConversionGrade5From.toString())
            && parseFloat(attestationRange.attestationConversionGrade4To.toString()) >= parseFloat(attestationRange.attestationConversionGrade4From.toString())
            && parseFloat(attestationRange.attestationConversionGrade3To.toString()) >= parseFloat(attestationRange.attestationConversionGrade3From.toString())
            && parseFloat(attestationRange.attestationConversionGrade2To.toString()) >= parseFloat(attestationRange.attestationConversionGrade2From.toString());
    }
    
    function totalConversionRangeFulfilled() {
        return parseFloat(range.grade5From) > parseFloat(range.grade4To)
            && (!parseFloat(range.grade4From) && !parseFloat(range.grade3To)
                || parseFloat(range.grade4From) > parseFloat(range.grade3To))
            && (!parseFloat(range.grade3From) && !parseFloat(range.grade2To)
                || parseFloat(range.grade3From) > parseFloat(range.grade2To))
            && parseFloat(range.grade5To) >= parseFloat(range.grade5From)
            && parseFloat(range.grade4To) >= parseFloat(range.grade4From)
            && parseFloat(range.grade3To) >= parseFloat(range.grade3From)
            && parseFloat(range.grade2To) >= parseFloat(range.grade2From);
    }
    
    function commentsAndWorkOffDetailsFulfilled() {
        let result = true;
        disciplineRequirements.forEach((item) => {
            if (!item.comment || !item.workOff) {
                result = false;
            }
        });
        
        return result;
    }
    
    function examTasksFulfilled() {
        return examTasks.length > 0 && examTasks.find(item => !item.taskType || !item.points) === undefined;
    }
    
    function examTasksAreCorrect() {
        let sum = 0;
        examTasks.forEach((item) => {
            sum += parseFloat(item.points.toString());
        });
        
        return sum <= examTasksMaxPoints;
    }
    
    function totalPointsAreCorrect() {
        return totalPoints() <= 64;
    }
    
    function readyForSaving() {
        if (!attestationGradesFulfilled()) {
            alert('Заполните преобразование баллов для рубежной аттестации');
            return false;
        }
        
        if (!attestationGradesAreCorrect()) {
            alert('Заполните преобразование баллов рубежной аттестации корректно. Нарушена последовательность баллов');
            return false;
        }
        
        if (!disciplineRequirementsFulfilled()) {
            alert('Заполните требования по дисциплине');
            return false;
        }
        
        // if (!disciplineRequirementsConversionFulfilled()) {
        //     alert('Заполните преобразование баллов по всем типам требований по дисциплине');
        //     return false;
        // }
        
        if (totalPoints() === 0) {
            alert('Заполните баллы в таблицах "Контроль посещаемости" и "Контроль успеваемости"')
            return false;
        }
        
        if (!totalConversionRangeFulfilled()) {
            alert('Заполните корректно преобразование баллов в пункте "Максимальное количество баллов по контролю посещаемости и текущему контролю успеваемости обучающегося"');
            return false;
        }
        
        if (!commentsAndWorkOffDetailsFulfilled()) {
            alert('Заполните комментарии и действия по отработке в разделе "Требования по дисциплине"');
            return false
        }
        
        if (!examTasksFulfilled()) {
            alert('Заполните сведения о баллах по экзаменационному билету');
            return false;
        }
        
        if (!examTasksAreCorrect()) {
            alert(`Сумма баллов по экзаменационному билету не должна превышать ${examTasksMaxPoints} баллов`);
            return false;
        }
        
        if (!totalPointsAreCorrect()) {
            alert('Сумма баллов за посещение лекционных и практических занятий, а также за текущий контроль (аудиторная и самостоятельная работа) не должна превышать 64 балла');
            return false;
        }
        
        return true;
    }

    const handleSave = async () => {
        if (!readyForSaving())
            return;
        
        setIsSaving(true);
        
        const themesOfFirstPartOfSemester = [];
        for (let i = 0; i <= secondSemesterPosition; i+=1) {
            for (let j = 0; j < copyOfThemes[i].lessonTypes?.length ?? 0; j+=1) {
                copyOfThemes[i].lessonTypes[j].themePlanIds.forEach((themePlanId) => {
                   themesOfFirstPartOfSemester.push(themePlanId); 
                });
            }
        }

        const computedRequest = {
            techMapId: techMapData?.data?.disciplineTechMapId ?? 0,
            courseId: parseInt(courseId, 10),
            disciplineId: parseInt(disciplineId, 10),
            virtualGroupId: parseInt(virtualGroupId, 10),
            standardLectureHoursFrom,
            standardLectureHoursTo,
            standardAuditoriumHoursFrom,
            standardAuditoriumHoursTo,
            disciplineLectureHoursMaximum,
            disciplineAuditoriumHoursMaximum,
            attestationConversionGrade5From: parseFloat(attestationRange.attestationConversionGrade5From.toString() ?? '0'),
            attestationConversionGrade4From: parseFloat(attestationRange.attestationConversionGrade4From.toString() ?? '0'),
            attestationConversionGrade3From: parseFloat(attestationRange.attestationConversionGrade3From.toString() ?? '0'),
            attestationConversionGrade2From: parseFloat(attestationRange.attestationConversionGrade2From.toString() ?? '0'),
            attestationConversionGrade5To: parseFloat(attestationRange.attestationConversionGrade5To.toString() ?? '0'),
            attestationConversionGrade4To: parseFloat(attestationRange.attestationConversionGrade4To.toString() ?? '0'),
            attestationConversionGrade3To: parseFloat(attestationRange.attestationConversionGrade3To.toString() ?? '0'),
            attestationConversionGrade2To: parseFloat(attestationRange.attestationConversionGrade2To.toString() ?? '0'),
            themesOfFirstPartOfSemester,
            examTasks: examTasks?.map((item) => {
                return {
                    taskType: item.taskType ?? 0,
                    orderNumber: item.orderNumber ?? 0,
                    points: parseFloat(item.points.toString() ?? '0'),
                    examTaskId: item.examTaskId ?? 0
                }
            }),
            disciplineRequirements: disciplineRequirements?.map((item) => {
                return {
                    key: item.key, // Date object as key
                    gradeTypeTitle: item.gradeTypeTitle ?? '',
                    points: parseFloat(item.points ?? '0'),
                    comment: item.comment ?? 0,
                    workOff: item.workOff ?? '',
                    maxPoints: parseFloat(item.maxPoints?.toString() ?? '0'),
                    controlType: item.controlType ?? 0,
                    conversionGrade5: parseFloat(item.points ?? '0') * grsParams.grsOptions.grade5Multiplier, // parseFloat(item.conversionGrade5 ?? '0'),
                    conversionGrade4: parseFloat(item.points ?? '0') * grsParams.grsOptions.grade4Multiplier, // 75% от макс оценки // parseFloat(item.conversionGrade4 ?? '0'),
                    conversionGrade3: parseFloat(item.points ?? '0') * grsParams.grsOptions.grade3Multiplier, // 50% от макс оценки // parseFloat(item.conversionGrade3 ?? '0'),
                    conversionGrade2: parseFloat(item.points ?? '0') * grsParams.grsOptions.grade2Multiplier, // 30% от макс оценки // parseFloat(item.conversionGrade2 ?? '0')
                }
            }),
            conversionRange: {
                grade2From: parseFloat(range?.grade2From ?? 0),
                grade2To: parseFloat(range?.grade2To ?? '0'),
                grade3From: parseFloat(range?.grade3From ?? '0'),
                grade3To: parseFloat(range?.grade3To ?? '0'),
                grade4From: parseFloat(range?.grade4From ?? '0'),
                grade4To: parseFloat(range?.grade4To ?? '0'),
                grade5From: parseFloat(range?.grade5From ?? '0'),
                grade5To: parseFloat(range?.grade5To ?? '0')
            },
            themes: copyOfThemes?.map((theme) => {
                return {
                    lessonTypes: theme.lessonTypes.map(lt => {
                        return {
                            lessonTypeId: lt.lessonTypeId,
                            themePlanIds: lt.themePlanIds
                        }
                    }),
                    orderNumber: theme.orderNumber,
                    lecturesHours: theme.lecturesHours ?? 0,
                    lecturesGrade: parseFloat(theme.lecturesGrade ?? '0'),
                    seminarsHours: theme.seminarsHours ?? 0,
                    seminarsGrade: parseFloat(theme.seminarsGrade ?? '0'),
                    labsHours: theme.labsHours ?? 0,
                    labsGrade: parseFloat(theme.labsGrade ?? '0'),
                    activities: theme.activities?.map((activity) => {
                        return {
                            association: activity.association, // associated discipline requirement (link)
                            points: parseFloat(activity.points)
                        }
                    })
                }
            })
        }

        await saveDataRequest({data: computedRequest}).unwrap().then((fulfilled) => {
            if (fulfilled?.success) {
                navigate('/journalmain');
            } else {
                fulfilled.errors.map((item) => {
                    alert(item);
                    return 1;
                });

                setIsSaving(false);
            }
        }).catch(() => {
            setIsSaving(false);
            alert('Ошибка');
        });
    };

    function updateSecondSemesterPosition(index, move) {
        if (index === 0 && move < 0)
            return;

        setSecondSemesterPosition(index + move);
    }

    function attendanceEditField(property, item) {
        return <TextField
            size={'small'}
            value={item[property] ?? 0}
            onChange={(e) => {
                let newValue = numbersOnly(e.target.value);
                if ((property === 'lecturesHours' || property === 'seminarsHours' || property === 'labsHours') && newValue > 0 && newValue < 2)
                    newValue = 2;
                
                item[property] = newValue;
                applyVisualChanges();
            }}
        />
    }

    function sumAttendanceGradeForRow(item) {
        const lecturesGrade = parseFloat(item.lecturesGrade !== undefined && item.lecturesGrade !== null ? item.lecturesGrade : '0');
        const seminarsGrade = parseFloat(item.seminarsGrade !== undefined && item.seminarsGrade !== null ? item.seminarsGrade : '0');
        const labsGrade = parseFloat(item.labsGrade !== undefined && item.labsGrade !== null ? item.labsGrade : '0');

        return (lecturesGrade + seminarsGrade + labsGrade).toFixed(2);
    }

    function sumAttendanceGradeFromTo(from, to) {
        const sum = parseFloat(sumAttendanceByProperty('lecturesGrade', from, to))
                + parseFloat(sumAttendanceByProperty('seminarsGrade', from, to))
                + parseFloat(sumAttendanceByProperty('labsGrade', from, to));
        
        console.log('sumAttendanceGradeFromTo', 
            sumAttendanceByProperty('lecturesGrade', from, to),
            sumAttendanceByProperty('seminarsGrade', from, to),
            sumAttendanceByProperty('labsGrade', from, to),
            sum,
            parseFloat(sum.toString()).toFixed(2));

        return sum === undefined ? 0 : parseFloat(sum.toString()).toFixed(2);
    }

    function sumAttendanceByProperty(property, from, to) {
        let sum = 0;
        copyOfThemes.slice(from, to + 1).forEach((item) => {
            sum += parseFloat(item[property] !== undefined && item[property] !== null ? item[property] : '0');
        })

        return sum.toFixed(2);
    }

    function sumHoursByDisciplineRequirement(requirementItem, semesterPart, theme) {
        if (theme) {
            return sumHoursByDisciplineRequirementTheme(theme);
        }

        let sum = 0;
        copyOfThemes?.slice(semesterPart === 1 || semesterPart === null ? 0 : secondSemesterPosition + 1,
            semesterPart === 1 && semesterPart !== null ? secondSemesterPosition + 1 : copyOfThemes.length)
            .forEach((theme) => {
                const requirements = theme.activities?.filter((item) => requirementItem === null || item.association?.key === requirementItem.key);
                requirements?.forEach((item) => {
                    sum += parseFloat(item.points ?? '0');
                });
            });

        return sum.toFixed(2);
    }

    function sumHoursByDisciplineRequirementTheme(theme) {
        let sum = 0;
        const requirements = theme.activities;
        requirements?.forEach((item) => {
            sum += parseFloat(item.points ?? '0');
        });

        return sum.toFixed(2);
    }

    function getRequirementRangeField(property) {
        return <TextField size={'small'}
                          sx={{width: '70px'}}
                          disabled={!canEdit}
                          value={!selectedRequirement ? '0' : selectedRequirement[property] ?? '0'}
                          onChange={(e) => {
                              selectedRequirement[property] = numbersOnly(e.target.value);
                              applyVisualChanges()
                          }}/>
    }

    function getSemesterPointsRangeField(property) {
        const sumOfPoints = totalPoints();
        return <TextField size={'small'}
                          sx={{width: '70px'}}
                          disabled={!canEdit}
                          value={attestationRange[property]}
                          onChange={(e) => {
                              if (parseFloat(numbersOnly(e.target.value)) > sumOfPoints)
                                  return;
                              
                              attestationRange[property] = numbersOnly(e.target.value);
                              applyVisualChanges()
                          }}/>
    }

    function getRangeField(property, title) {
        return <TextField size={'small'}
                          type={'number'}
                          sx={{width: '70px'}}
                          label={title}
                          disabled
                          value={range[property]}
                          onChange={(e) => {
                              range[property] = e.target.value;
                              applyVisualChanges()
                          }}/>
    }

    function handleActivityHoursChange(event, themeItem, requirementItem) {
        const existingActivityLink = themeItem.activities?.find((activity) => activity.association?.key === requirementItem.key);
        if (existingActivityLink) {
            existingActivityLink.points = event.target.value;
        } else {
            if (!themeItem.activities)
                themeItem.activities = [];

            themeItem.activities.push({
                association: requirementItem,
                points: event.target.value
            });
        }

        applyVisualChanges();
    }

    function numbersOnly(input) {
        if (!input)
            return '';

        const allowedSymbols = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', ',', '.'];
        let result = '';
        input.split('').forEach((symbol, index) => {
            if (allowedSymbols.includes(symbol)) {
                result += symbol;
                // if (symbol === ',' || symbol === '.' && input.length === index + 1) {
                //     result += '0';
                // }
            }
        });

        result = result.replace(',', '.');

        return result;
    }
    
    function totalPoints() {
        const attGrade = parseFloat(sumAttendanceGradeFromTo(0, secondSemesterPosition ?? 0));
        // const gradePoints = parseFloat(sumHoursByDisciplineRequirement(null, 1, null));
        const gradePoints = sumDisciplineRequirementsMaxPoints();
        
        return parseFloat((attGrade + gradePoints).toString()).toFixed(2);
    }
    
    function attestationGradesFulfilled() {
        return attestationRange.attestationConversionGrade5From
            || attestationRange.attestationConversionGrade4From
            || attestationRange.attestationConversionGrade3From
            || attestationRange.attestationConversionGrade2From
            || attestationRange.attestationConversionGrade5To
            || attestationRange.attestationConversionGrade4To
            || attestationRange.attestationConversionGrade3To
            || attestationRange.attestationConversionGrade2To;
    }
    
    function handleTaskTypeChanged(newValue, examTask) {
        examTask.taskType = newValue;
        applyVisualChanges();
    }
    
    function handleAddExamTask() {
        examTasks.push({
            taskType: 0,
            orderNumber: (examTasks.sort((l,r) => l.orderNumber > r.orderNumber ? -1 : 1)[0]?.orderNumber ?? 0) + 1,
            points: 0
        });
        applyVisualChanges();
    }
    
    function handleTaskPointsChanged(value, examTask) {
        let newValue = numbersOnly(value);
        if (parseFloat(newValue) > examTasksMaxPoints) {
            newValue = examTasksMaxPoints.toString();  
        }
        
        examTask.points = newValue;
        applyVisualChanges();
    }
    
    function handleRemoveExamTask(examTask) {
        examTasks.splice(examTasks.indexOf(examTask), 1);
        applyVisualChanges();
    }
    
    function fulfillAttendanceCells(newValue, propertyName) {
        const maxValue = 64;
        if (!copyOfThemes)
            return;

        let value = numbersOnly(newValue);
        if (parseFloat(value) > maxValue) {
            value = maxValue.toString();
        }
        
        copyOfThemes.forEach((theme) => {
            theme[propertyName] = value;
        });
        
        applyVisualChanges();
    }
    
    function getAttendanceFulfillmentField(property) {
        return <TextField size={'small'}
                          onChange={(event) => {fulfillAttendanceCells(event.target.value, property)}}
                          defaultValue={0} />
    }
    
    function handleSetDistributionPoints(val) {
        distributionData.points = numbersOnly(val);
        distributePointsAndHoursV2();
    }

    function handleSetDistributionHours(val) {
        distributionData.hours = numbersOnly(val);
        distributePointsAndHoursV2();
    }
    
    function distributePointsAndHoursV2() {
        const pointsPerHour = (distributionData.points / getTotalAuditoriumHours()).toFixed(2);

        // distribute points by cells
        copyOfThemes?.forEach((theme) => {
            if (theme.lessonTypes?.find((lt) => lt.lessonTypeId === 6)) {
                theme.lecturesGrade = pointsPerHour * theme.lecturesHours;
            }

            if (theme.lessonTypes?.find((lt) => lt.lessonTypeId === 3 || lt.lessonTypeId === 4)) {
                theme.seminarsGrade = pointsPerHour * theme.seminarsHours;
            }

            if (theme.lessonTypes?.find((lt) => lt.lessonTypeId === 1)) {
                theme.labsGrade = pointsPerHour * theme.labsHours;
            }
        });

        applyVisualChanges();
    }
    
    function distributePointsAndHours() {
        if (true)
            return; // temp disabled
        
        let numberOfLectureThemes = 0;
        let numberOfSeminarThemes = 0;
        let numberOfLabThemes = 0;
        copyOfThemes?.forEach((theme) => {
            numberOfLectureThemes += theme.lessonTypes?.filter((lt) => lt.lessonTypeId === 6).length;
            numberOfSeminarThemes += theme.lessonTypes?.filter((lt) => lt.lessonTypeId === 3 || lt.lessonTypeId === 4).length;
            numberOfLabThemes += theme.lessonTypes?.filter((lt) => lt.lessonTypeId === 1).length;
        });
        
        let sumOfThemes = numberOfLectureThemes + numberOfSeminarThemes + numberOfLabThemes;
        if (!sumOfThemes)
            return;
        
        sumOfThemes = sumOfThemes.toFixed(2);
        
        const lecturePart = numberOfLectureThemes / sumOfThemes;
        const seminarPart = numberOfSeminarThemes / sumOfThemes;
        const labPart = numberOfLabThemes / sumOfThemes;
        const distributedLectureHours = distributionData.hours * lecturePart / numberOfLectureThemes;
        const distributedLecturePoints = distributionData.points * lecturePart / numberOfLectureThemes;
        const distributedSeminarHours = distributionData.hours * seminarPart / numberOfSeminarThemes;
        const distributedSeminarPoints = distributionData.points * seminarPart / numberOfSeminarThemes;
        const distributedLabHours = distributionData.hours * labPart / numberOfLabThemes;
        const distributedLabPoints = distributionData.points * labPart / numberOfLabThemes;
        
        // distribute points by cells
        copyOfThemes?.forEach((theme) => {
            if (theme.lessonTypes?.find((lt) => lt.lessonTypeId === 6)) {
                theme.lecturesHours = distributedLectureHours * theme.lessonTypes.filter((lt) => lt.lessonTypeId === 6).length;
                theme.lecturesGrade = distributedLecturePoints * theme.lessonTypes.filter((lt) => lt.lessonTypeId === 6).length;
            }

            if (theme.lessonTypes?.find((lt) => lt.lessonTypeId === 3 || lt.lessonTypeId === 4)) {
                theme.seminarsHours = distributedSeminarHours * theme.lessonTypes.filter((lt) => lt.lessonTypeId === 3 || lt.lessonTypeId === 4).length;
                theme.seminarsGrade = distributedSeminarPoints * theme.lessonTypes.filter((lt) => lt.lessonTypeId === 3 || lt.lessonTypeId === 4).length
            }

            if (theme.lessonTypes?.find((lt) => lt.lessonTypeId === 1)) {
                theme.labsHours = distributedLabHours * theme.lessonTypes.filter((lt) => lt.lessonTypeId === 1).length;
                theme.labsGrade = distributedLabPoints * theme.lessonTypes.filter((lt) => lt.lessonTypeId === 1).length;
            }
        });
        
        applyVisualChanges();
    }
    
    function sumDisciplineRequirementsMaxPoints() {
        let sum = 0;
        disciplineRequirements?.forEach((dr) => {
            if (dr.maxPoints) {
                sum += parseFloat(dr.maxPoints.toString());
            }
        });
        
        return sum;
    }
    
    function getTotalAuditoriumHours() {
        return parseFloat(sumAttendanceByProperty('lecturesHours', 0, copyOfThemes.length - 1))
        + parseFloat(sumAttendanceByProperty('seminarsHours', 0, copyOfThemes.length - 1))
        + parseFloat(sumAttendanceByProperty('labsHours', 0, copyOfThemes.length - 1));
    }
    
    async function handleClearTechMap() {
        if (!canEdit)
            return;

        if (window.confirm('Вы уверены, что хотите очистить технологическую карту?')) {
            setIsRemovingTechMap(true);
            await removeTechMapRequest({
                data: {
                    courseId,
                    disciplineId,
                    virtualGroupId
                }
            }).unwrap()
                .then(() => {
                    window.location.reload();
                    // navigate(`/grade-rating-system/${courseId}/${disciplineId}/${virtualGroupId}`);
                })
                .catch((error) => {
                    setIsRemovingTechMap(false);
                    alert('Ошибка');
                });
        }
    }

    return (
        <MainLayout>
            <PageTitle title={`Технологическая карта по дисциплине`}/>

            <Container>
                <Stack direction="column"
                       padding="30px 0px 0px 0px"
                       spacing={2}>
                    <Stack>
                        <Stack justifyContent="space-between" mb={5} direction="row">
                            <Typography variant="h4">
                                {isTechMapLoading ? <CircularProgress size={20} /> : <></>}
                                Технологическая карта
                                <IconButton size={'small'}
                                            target={'_blank'}
                                            href={`/print-tech-map/${courseId}/${disciplineId}/${virtualGroupId}/0`}>
                                    <PrintIcon/>
                                </IconButton>
                            </Typography>
                            
                            <Button variant={'outlined'}
                                    startIcon={<Help />}
                                    target={'_blank'}
                                    href={`/assets/grs_instruction.pdf`}
                                    size={'small'}>Инструкция</Button>
                        </Stack>

                        <Typography variant="h6">
                            по дисциплине {disciplineData?.disciplineName}<br/>
                            {virtualGroupId > 0 ? <>для сводной группы</> : <>для студентов, обучающихся по направлению {disciplineData?.courseName}</>}
                        </Typography>
                    </Stack>

                    <Alert severity="warning">Перед заполнением сведений БРС убедитесь, что вы заполнили список
                        тем <Button href={`/editthemes/${courseId}/${disciplineId}/${virtualGroupId}`}
                                    startIcon={<ArrowRight/>}>Перейти</Button></Alert>

                    {!canEdit
                        ? <Alert severity="warning">Редактирование тех. карты недоступно, так как по ней имеются
                            заполненные занятия</Alert>
                        : <></>}

                    <Card>
                        <CardContent>
                            <Stack direction={'row'} justifyContent={'space-between'}>
                                <Typography variant={'h5'}>{isTechMapLoading ? <CircularProgress size={20} /> : <></>} Требования по дисциплине <IconButton size={'small'}
                                                                                                disabled={!canEdit}
                                                                                                onClick={() => {
                                                                                                    disciplineRequirements?.push({key: new Date()});
                                                                                                    applyVisualChanges()
                                                                                                }}><AddIcon/></IconButton></Typography>

                                {techMapData?.data?.disciplineTechMapId > 0
                                ? <Button disabled={!canEdit}
                                          color={'error'}
                                          size={'small'}
                                          startIcon={isRemovingTechMap ? <CircularProgress size={20}/> : <DeleteIcon/>}
                                          onClick={() => {handleClearTechMap()}}
                                          variant={'outlined'}>Очистить тех. карту</Button>
                                : <></>}
                            </Stack>
                        </CardContent>
                        <Modal
                            open={openGradeConversionModal}
                            onClose={() => setOpenGradeConversionModal(false)}
                        >
                            <Box style={modalStyle}>
                                <Typography id="modal-modal-title" variant="h6" component="h2">
                                    Преобразование баллов для "{selectedRequirement?.gradeTypeTitle}"
                                </Typography>
                                <Table size={'small'}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align={'right'}>100-балльная система</TableCell>
                                            <TableCell align={'left'}>5-балльная система</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell align={'right'}>
                                                <Stack direction={'row'} spacing={1} justifyContent={'end'}
                                                       alignItems={'center'}>
                                                    {getRequirementRangeField('conversionGrade5')}
                                                </Stack>
                                            </TableCell>
                                            <TableCell align={'left'}>Отлично / "зачтено"</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell align={'right'}>
                                                <Stack direction={'row'} spacing={1} justifyContent={'end'}
                                                       alignItems={'center'}>
                                                    {getRequirementRangeField('conversionGrade4')}
                                                </Stack>
                                            </TableCell>
                                            <TableCell align={'left'}>Хорошо / "зачтено"</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell align={'right'}>
                                                <Stack direction={'row'} spacing={1} justifyContent={'end'}
                                                       alignItems={'center'}>
                                                    {getRequirementRangeField('conversionGrade3')}
                                                </Stack>
                                            </TableCell>
                                            <TableCell align={'left'}>Удовлетворительно / "зачтено"</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell align={'right'}>
                                                <Stack direction={'row'} spacing={1} justifyContent={'end'}
                                                       alignItems={'center'}>
                                                    {getRequirementRangeField('conversionGrade2')}
                                                </Stack>
                                            </TableCell>
                                            <TableCell align={'left'}>Неудовлетворительно</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                                <br/>
                                <Button fullWidth
                                        variant={'contained'}
                                        onClick={() => setOpenGradeConversionModal(false)}>Сохранить</Button>
                            </Box>
                        </Modal>
                        
                        <TableContainer>
                            <Table size={'small'}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align={'center'}>№</TableCell>
                                        <TableCell align={'center'}>Активность</TableCell>
                                        <TableCell align={'center'}>Баллы*</TableCell>
                                        <TableCell align={'center'}>Комментарии</TableCell>
                                        <TableCell align={'center'}>Действия по отработке</TableCell>
                                        <TableCell align={'center'}>Макс. кол-во баллов</TableCell>
                                        <TableCell align={'center'}>Тип</TableCell>
                                        <TableCell align={'center'}><></></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {disciplineRequirements?.map((item, index) => {
                                        return <TableRow>
                                            <TableCell align={'center'}>{index + 1}</TableCell>
                                            <TableCell align={'center'}>
                                                <TextField size={'small'}
                                                           disabled={!canEdit}
                                                           value={item.gradeTypeTitle}
                                                           onChange={(event) => {
                                                               item.gradeTypeTitle = event.target.value;
                                                               applyVisualChanges()
                                                           }}/>
                                            </TableCell>
                                            <TableCell align={'center'}>
                                                <TextField size={'small'}
                                                           disabled={!canEdit}
                                                           value={item.points ?? 0}
                                                           onChange={(event) => {
                                                               item.points = numbersOnly(event.target.value);
                                                               copyOfThemes?.forEach((theme) => {
                                                                   handleActivityHoursChange(event, theme, item);
                                                               });
                                                               
                                                               applyVisualChanges()
                                                           }}/>
                                            </TableCell>
                                            <TableCell align={'center'}>
                                                <TextField size={'small'}
                                                           value={item.comment}
                                                           disabled={!canEdit}
                                                           onChange={(event) => {
                                                               item.comment = event.target.value;
                                                               applyVisualChanges()
                                                           }}/>
                                            </TableCell>
                                            <TableCell align={'center'}>
                                                <TextField size={'small'}
                                                           value={item.workOff}
                                                           disabled={!canEdit}
                                                           onChange={(event) => {
                                                               item.workOff = event.target.value;
                                                               applyVisualChanges()
                                                           }}/>
                                            </TableCell>
                                            <TableCell align={'center'}>
                                                <TextField size={'small'}
                                                           value={item.maxPoints ?? 0}
                                                           disabled={!canEdit}
                                                           onChange={(event) => {
                                                               item.maxPoints = numbersOnly(event.target.value);
                                                               applyVisualChanges()
                                                           }}/>
                                            </TableCell>
                                            <TableCell align={'center'}>
                                                <RadioGroup
                                                    aria-labelledby="requirementType"
                                                    defaultValue="0"
                                                    value={item.controlType}
                                                    name="requirementType-group"
                                                >
                                                    <FormControlLabel value="0"
                                                                      control={<Radio size={'small'}
                                                                                      disabled={!canEdit}
                                                                                      onChange={(event) => {
                                                                                          item.controlType = parseInt(event.target.value, 10);
                                                                                          applyVisualChanges()
                                                                                      }}/>}
                                                                      label={<Typography fontSize={'smaller'}>Аудиторная
                                                                          контактная работа обучающегося</Typography>}/>
                                                    <FormControlLabel value="1"
                                                                      control={<Radio size={'small'}
                                                                                      disabled={!canEdit}
                                                                                      onChange={(event) => {
                                                                                          item.controlType = parseInt(event.target.value, 10);
                                                                                          applyVisualChanges()
                                                                                      }}/>}
                                                                      label={<Typography fontSize={'smaller'}>Контроль
                                                                          самостоятельной работы
                                                                          обучающегося</Typography>}/>
                                                </RadioGroup>
                                            </TableCell>
                                            <TableCell align={'right'}>
                                                <IconButton size={'small'} 
                                                            color={'error'}
                                                            disabled={!canEdit}
                                                            onClick={() => {
                                                                disciplineRequirements.splice(index, 1);
                                                                applyVisualChanges()
                                                            }}>
                                                    <DeleteIcon/>
                                                </IconButton> 
                                            </TableCell>
                                        </TableRow>
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <br/>
                        <Typography fontSize={'smaller'} style={{'marginLeft': '10px'}}>
                            * В расчете на одного обучающегося за единицу оценки
                        </Typography>
                    </Card>

                    <Card>
                        <CardContent>
                            <Stack direction="row" alignItems="center" justifyContent="space-between">
                                <Typography variant={'h5'}>Контроль посещаемости</Typography>

                                <Stack direction="row" spacing={2}>
                                    {attendanceDistribution
                                        ? <>
                                            <TextField size={'small'}
                                                       value={getTotalAuditoriumHours()}
                                                       disabled
                                                       onChange={(event) => { handleSetDistributionHours(event.target.value) }}
                                                       label={'Сумма аудиторных часов'} />

                                            <TextField size={'small'}
                                                       value={distributionData.points}
                                                       onChange={(event) => { handleSetDistributionPoints(event.target.value) }}
                                                       label={'Сумма баллов'} />
                                        </>
                                        : <></>}

                                    <Button size={'small'}
                                            variant={'outlined'}
                                            onClick={() => {
                                                setAttendanceDistribution(true);
                                            }}
                                            disabled={!canEdit}>Распределить равномерно</Button>
                                </Stack>
                            </Stack>
                        </CardContent>
                        <TableContainer>
                            <Table size={'small'}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align={'center'}>№ п/п</TableCell>
                                        <TableCell align={'center'}>Наименование тем дисциплины</TableCell>
                                        <TableCell align={'center'}>Лекции, часов в РП</TableCell>
                                        <TableCell align={'center'}>Итого баллов*</TableCell>
                                        <TableCell align={'center'}>Практические занятия, часов в РП</TableCell>
                                        <TableCell align={'center'}>Итого баллов*</TableCell>
                                        <TableCell align={'center'}>Лабораторные занятия, часов в РП</TableCell>
                                        <TableCell align={'center'}>Итого баллов*</TableCell>
                                        <TableCell align={'center'} rowSpan={2} style={totalStyle}>ВСЕГО БАЛЛОВ</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        <TableCell colSpan={9} align={'center'}>
                                            <Typography fontWeight={'bold'}>Первая половина семестра</Typography>
                                        </TableCell>
                                    </TableRow>
                                    {copyOfThemes?.map((item, index) => {
                                        return <>
                                            <TableRow>
                                                <TableCell align={'center'}>{index + 1}</TableCell>
                                                <TableCell align={'center'}>{item.theme}</TableCell>
                                                <TableCell
                                                    align={'center'}>{attendanceEditField('lecturesHours', item)}</TableCell>
                                                <TableCell
                                                    align={'center'}>{attendanceEditField('lecturesGrade', item)}</TableCell>
                                                <TableCell
                                                    align={'center'}>{attendanceEditField('seminarsHours', item)}</TableCell>
                                                <TableCell
                                                    align={'center'}>{attendanceEditField('seminarsGrade', item)}</TableCell>
                                                <TableCell
                                                    align={'center'}>{attendanceEditField('labsHours', item)}</TableCell>
                                                <TableCell
                                                    align={'center'}>{attendanceEditField('labsGrade', item)}</TableCell>
                                                <TableCell align={'center'}
                                                           style={totalStyle}>{sumAttendanceGradeForRow(item)}</TableCell>
                                            </TableRow>
                                            {secondSemesterPosition === index || (index === copyOfThemes.length - 1 && secondSemesterPosition > copyOfThemes.length - 1)
                                                ? <>
                                                    <TableRow>
                                                        <TableCell align={'center'} colSpan={2} style={totalStyle}>
                                                            Общее количество аудиторных занятий за 1 половину семестра
                                                        </TableCell>
                                                        <TableCell align={'center'}
                                                                   style={totalStyle}>{sumAttendanceByProperty('lecturesHours', 0, index)}</TableCell>
                                                        <TableCell align={'center'}
                                                                   style={totalStyle}>{sumAttendanceByProperty('lecturesGrade', 0, index)}</TableCell>
                                                        <TableCell align={'center'}
                                                                   style={totalStyle}>{sumAttendanceByProperty('seminarsHours', 0, index)}</TableCell>
                                                        <TableCell align={'center'}
                                                                   style={totalStyle}>{sumAttendanceByProperty('seminarsGrade', 0, index)}</TableCell>
                                                        <TableCell align={'center'}
                                                                   style={totalStyle}>{sumAttendanceByProperty('labsHours', 0, index)}</TableCell>
                                                        <TableCell align={'center'}
                                                                   style={totalStyle}>{sumAttendanceByProperty('labsGrade', 0, index)}</TableCell>
                                                        <TableCell align={'center'}
                                                                   style={totalStyle}>{sumAttendanceGradeFromTo(0, index)}</TableCell>
                                                    </TableRow>

                                                    <TableRow>
                                                        <TableCell colSpan={9} align={'center'}>
                                                            <Stack>
                                                                <Stack direction={'row'} alignItems={'center'}
                                                                       justifyContent={'center'}>
                                                                    <IconButton size={'small'}
                                                                                disabled={!canEdit}
                                                                                onClick={() => {
                                                                                    updateSecondSemesterPosition(index, -1)
                                                                                }}><ArrowUpward/></IconButton>
                                                                    <IconButton size={'small'}
                                                                                disabled={!canEdit}
                                                                                onClick={() => {
                                                                                    updateSecondSemesterPosition(index, 1)
                                                                                }}><ArrowDownward/></IconButton>
                                                                    <Typography fontWeight={'bold'}>Вторая половина
                                                                        семестра</Typography>
                                                                </Stack>
                                                            </Stack>
                                                        </TableCell>
                                                    </TableRow>
                                                </>
                                                : <></>}
                                        </>
                                    })}

                                    <TableRow>
                                        <TableCell align={'center'} colSpan={2} style={totalStyle}>Общее количество
                                            аудиторных занятий за 2 половину семестра</TableCell>
                                        <TableCell align={'center'}
                                                   style={totalStyle}>{sumAttendanceByProperty('lecturesHours', secondSemesterPosition + 1, copyOfThemes.length - 1)}</TableCell>
                                        <TableCell align={'center'}
                                                   style={totalStyle}>{sumAttendanceByProperty('lecturesGrade', secondSemesterPosition + 1, copyOfThemes.length - 1)}</TableCell>
                                        <TableCell align={'center'}
                                                   style={totalStyle}>{sumAttendanceByProperty('seminarsHours', secondSemesterPosition + 1, copyOfThemes.length - 1)}</TableCell>
                                        <TableCell align={'center'}
                                                   style={totalStyle}>{sumAttendanceByProperty('seminarsGrade', secondSemesterPosition + 1, copyOfThemes.length - 1)}</TableCell>
                                        <TableCell align={'center'}
                                                   style={totalStyle}>{sumAttendanceByProperty('labsHours', secondSemesterPosition + 1, copyOfThemes.length - 1)}</TableCell>
                                        <TableCell align={'center'}
                                                   style={totalStyle}>{sumAttendanceByProperty('labsGrade', secondSemesterPosition + 1, copyOfThemes.length - 1)}</TableCell>
                                        <TableCell align={'center'}
                                                   style={totalStyle}>{sumAttendanceGradeFromTo(secondSemesterPosition + 1, copyOfThemes.length - 1)}</TableCell>
                                    </TableRow>

                                    <TableRow>
                                        <TableCell align={'center'} colSpan={2} style={totalStyle}>Всего посещение аудиторных занятий</TableCell>
                                        <TableCell align={'center'}
                                                   style={totalStyle}>{sumAttendanceByProperty('lecturesHours', 0, copyOfThemes.length - 1)}</TableCell>
                                        <TableCell align={'center'}
                                                   style={totalStyle}>{sumAttendanceByProperty('lecturesGrade', 0, copyOfThemes.length - 1)}</TableCell>
                                        <TableCell align={'center'}
                                                   style={totalStyle}>{sumAttendanceByProperty('seminarsHours', 0, copyOfThemes.length - 1)}</TableCell>
                                        <TableCell align={'center'}
                                                   style={totalStyle}>{sumAttendanceByProperty('seminarsGrade', 0, copyOfThemes.length - 1)}</TableCell>
                                        <TableCell align={'center'}
                                                   style={totalStyle}>{sumAttendanceByProperty('labsHours', 0, copyOfThemes.length - 1)}</TableCell>
                                        <TableCell align={'center'}
                                                   style={totalStyle}>{sumAttendanceByProperty('labsGrade', 0, copyOfThemes.length - 1)}</TableCell>
                                        <TableCell align={'center'}
                                                   style={totalStyle}>{sumAttendanceGradeFromTo(0, copyOfThemes.length - 1)}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Card>


                    <Card>
                        <CardContent>
                            <Typography variant={'h5'}>Контроль успеваемости</Typography>
                        </CardContent>
                        <Stack spacing={2}>
                            {
                                disciplineRequirements?.length > 0
                                    ? <> {/*
                                        <TableContainer>
                                        <Table size={'small'}>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell align={'center'} rowSpan={2}>№ п/п</TableCell>
                                                    <TableCell align={'center'} rowSpan={2} style={delimiterStyle}>
                                                        Наименование тем дисциплины</TableCell>
                                                    {disciplineRequirements?.filter((item) => !item.controlType).length > 0
                                                        ?
                                                    <TableCell align={'center'}
                                                               colSpan={disciplineRequirements?.filter((item) => !item.controlType).length}
                                                               style={delimiterStyle}>
                                                        Аудиторная контактная работа обучающегося
                                                    </TableCell>
                                                        : <></>}

                                                    {disciplineRequirements?.filter((item) => item.controlType).length > 0
                                                        ?
                                                    <TableCell align={'center'}
                                                               colSpan={disciplineRequirements?.filter((item) => item.controlType).length}>
                                                        Контроль самостоятельной работы обучающегося</TableCell>
                                                        : <></>}
                                                    <TableCell align={'center'}
                                                               rowSpan={2}
                                                               style={totalStyle}>ВСЕГО</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    {disciplineRequirements?.filter((item) => !item.controlType).map((item, index) => {
                                                        return <TableCell align={'center'}
                                                                          style={index === disciplineRequirements?.filter((item) => !item.controlType).length - 1 ? delimiterStyle : {}}>{item.gradeTypeTitle}</TableCell>
                                                    })}

                                                    {disciplineRequirements?.filter((item) => item.controlType).map((item) => {
                                                        return <TableCell align={'center'}>{item.gradeTypeTitle}</TableCell>
                                                    })}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell colSpan={9} align={'center'}>
                                                        <Typography fontWeight={'bold'}>Первая половина
                                                            семестра</Typography>
                                                    </TableCell>
                                                </TableRow>
                                                {copyOfThemes?.map((item, index) => {
                                                    return <>
                                                        <TableRow>
                                                            <TableCell align={'center'}>{index + 1}</TableCell>
                                                            <TableCell align={'center'}>{item.theme}</TableCell>
                                                            {disciplineRequirements?.filter((req) => !req.controlType).map((req) => {
                                                                return <TableCell align={'center'}>
                                                                    <TextField
                                                                        disabled={!canEdit}
                                                                        size={'small'}
                                                                        sx={{width: '70px'}}
                                                                        onChange={(event) => {
                                                                            handleActivityHoursChange(event, item, req);
                                                                        }}
                                                                        value={item.activities?.find((activity) => activity.association?.key === req.key)?.points ?? '0'}/>
                                                                </TableCell>
                                                            })}

                                                            {disciplineRequirements?.filter((req) => req.controlType).map((req) => {
                                                                return <TableCell align={'center'}>
                                                                    <TextField
                                                                        disabled={!canEdit}
                                                                        size={'small'}
                                                                        sx={{width: '70px'}}
                                                                        onChange={(event) => {
                                                                            handleActivityHoursChange(event, item, req);
                                                                        }}
                                                                        value={item.activities?.find((activity) => activity.association?.key === req.key)?.points ?? '0'}/>
                                                                </TableCell>
                                                            })}

                                                            <TableCell align={'center'}
                                                                       style={totalStyle}>{sumHoursByDisciplineRequirement(null, null, item)}</TableCell>
                                                        </TableRow>
                                                        {secondSemesterPosition === index || (index === copyOfThemes.length - 1 && secondSemesterPosition > copyOfThemes.length - 1)
                                                            ? <>
                                                                <TableRow>
                                                                    <TableCell align={'center'} colSpan={2}
                                                                               style={totalStyle}>Итого 1 половина
                                                                        семестра</TableCell>
                                                                    {disciplineRequirements?.filter((req) => !req.controlType).map((req) => {
                                                                        return <TableCell align={'center'}
                                                                                          style={totalStyle}>{sumHoursByDisciplineRequirement(req, 1, null)}</TableCell>
                                                                    })}

                                                                    {disciplineRequirements?.filter((req) => req.controlType).map((req) => {
                                                                        return <TableCell align={'center'}
                                                                                          style={totalStyle}>{sumHoursByDisciplineRequirement(req, 1, null)}</TableCell>
                                                                    })}

                                                                    <TableCell align={'center'}
                                                                               style={totalStyle}>{sumHoursByDisciplineRequirement(null, 1, null)}</TableCell>
                                                                </TableRow>

                                                                <TableRow>
                                                                    <TableCell colSpan={9} align={'center'}>
                                                                        <Stack direction={'row'} alignItems={'center'}
                                                                               justifyContent={'center'}>
                                                                            <IconButton size={'small'}
                                                                                        disabled={!canEdit}
                                                                                        onClick={() => {
                                                                                            updateSecondSemesterPosition(index, -1)
                                                                                        }}><ArrowUpward/></IconButton>
                                                                            <IconButton size={'small'}
                                                                                        disabled={!canEdit}
                                                                                        onClick={() => {
                                                                                            updateSecondSemesterPosition(index, 1)
                                                                                        }}><ArrowDownward/></IconButton>
                                                                            <Typography fontWeight={'bold'}>Вторая половина
                                                                                семестра</Typography>
                                                                        </Stack>
                                                                    </TableCell>
                                                                </TableRow>
                                                            </>
                                                            : <></>}
                                                    </>
                                                })}

                                                <TableRow>
                                                    <TableCell align={'center'} colSpan={2} style={totalStyle}>Итого 2
                                                        половина семестра</TableCell>
                                                    {disciplineRequirements?.filter((req) => !req.controlType).map((req) => {
                                                        return <TableCell align={'center'}
                                                                          style={totalStyle}>{sumHoursByDisciplineRequirement(req, 2, null)}</TableCell>
                                                    })}

                                                    {disciplineRequirements?.filter((req) => req.controlType).map((req) => {
                                                        return <TableCell align={'center'}
                                                                          style={totalStyle}>{sumHoursByDisciplineRequirement(req, 2, null)}</TableCell>
                                                    })}

                                                    <TableCell align={'center'}
                                                               style={totalStyle}>{sumHoursByDisciplineRequirement(null, 2, null)}</TableCell>
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell align={'center'} colSpan={2} style={totalStyle}>Всего за
                                                        семестр</TableCell>
                                                    {disciplineRequirements?.filter((req) => !req.controlType).map((req) => {
                                                        return <TableCell align={'center'}
                                                                          style={totalStyle}>{sumHoursByDisciplineRequirement(req, null, null)}</TableCell>
                                                    })}

                                                    {disciplineRequirements?.filter((req) => req.controlType).map((req) => {
                                                        return <TableCell align={'center'}
                                                                          style={totalStyle}>{sumHoursByDisciplineRequirement(req, null, null)}</TableCell>
                                                    })}

                                                    <TableCell align={'center'}
                                                               style={totalStyle}>{sumHoursByDisciplineRequirement(null, null, null)}</TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer> */}
                                    <Typography id="modal-modal-title" variant="h6" component="h2" textAlign={'center'}>
                                        Преобразование баллов для рубежной аттестации ({totalPoints()} макс.)
                                    </Typography>
                                    
                                    <Table size={'small'}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align={'right'}>100-балльная система
                                                <br />От - До</TableCell>
                                                <TableCell align={'left'}>5-балльная система</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell align={'right'}>
                                                    <Stack direction={'row'} spacing={1} justifyContent={'end'}
                                                           alignItems={'center'}>
                                                        {getSemesterPointsRangeField('attestationConversionGrade5From')}
                                                        <strong>-</strong>
                                                        {getSemesterPointsRangeField('attestationConversionGrade5To')}
                                                    </Stack>
                                                </TableCell>
                                                <TableCell align={'left'}>Отлично / "зачтено"</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell align={'right'}>
                                                    <Stack direction={'row'} spacing={1} justifyContent={'end'}
                                                           alignItems={'center'}>
                                                        {getSemesterPointsRangeField('attestationConversionGrade4From')}
                                                        <strong>-</strong>
                                                        {getSemesterPointsRangeField('attestationConversionGrade4To')}
                                                    </Stack>
                                                </TableCell>
                                                <TableCell align={'left'}>Хорошо / "зачтено"</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell align={'right'}>
                                                    <Stack direction={'row'} spacing={1} justifyContent={'end'}
                                                           alignItems={'center'}>
                                                        {getSemesterPointsRangeField('attestationConversionGrade3From')}
                                                        <strong>-</strong>
                                                        {getSemesterPointsRangeField('attestationConversionGrade3To')}
                                                    </Stack>
                                                </TableCell>
                                                <TableCell align={'left'}>Удовлетворительно / "зачтено"</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell align={'right'}>
                                                    <Stack direction={'row'} spacing={1} justifyContent={'end'}
                                                           alignItems={'center'}>
                                                        {getSemesterPointsRangeField('attestationConversionGrade2From')}
                                                        <strong>-</strong>
                                                        {getSemesterPointsRangeField('attestationConversionGrade2To')}
                                                    </Stack>
                                                </TableCell>
                                                <TableCell align={'left'}>Неудовлетворительно</TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                    </>
                                : <Alert severity={'warning'}>
                                    Сперва заполните пункт <strong>"Требования по дисциплине"</strong>
                                </Alert>
                            }

                            <br/>
                            <Divider/>

                            <CardContent>
                                <Typography variant={'h5'}>Экзаменационный билет</Typography>
                            </CardContent>
                            
                            <TableContainer>
                                <Table size={'small'}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align={'center'} width={100}>Номер вопроса</TableCell>
                                            <TableCell align={'center'} width={300}>Тип</TableCell>
                                            <TableCell align={'left'}>Кол-во баллов</TableCell>
                                            <TableCell align={'right'}>
                                                <Button startIcon={<AddIcon />}
                                                        onClick={() => handleAddExamTask()}>Добавить вопрос</Button>
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {examTasks.sort((l,r) => l.orderNumber > r.orderNumber ? 1 : -1).map((item, index) => {
                                            return <TableRow>
                                                <TableCell align={'center'}><strong>{index + 1}</strong></TableCell>
                                                <TableCell>
                                                    <TextField
                                                        select
                                                        size={'small'}
                                                        value={item.taskType}
                                                        onChange={(e) => handleTaskTypeChanged(e.target.value, item)}
                                                        fullWidth>
                                                        {examTaskTypes.map((option) => (
                                                            <MenuItem key={option.id} value={option.id}>
                                                                {option.title}
                                                            </MenuItem>
                                                        ))}
                                                    </TextField>
                                                </TableCell>
                                                <TableCell align={'left'}>
                                                    <TextField
                                                        size={'small'}
                                                        value={item.points}
                                                        onChange={(e) => handleTaskPointsChanged(e.target.value, item)}
                                                        fullWidth />
                                                </TableCell>
                                                <TableCell align={'right'}>
                                                    <IconButton color={'error'} onClick={() => handleRemoveExamTask(item)}>
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                            <br/>
                            <Divider/>

                            <TableContainer>
                                <Table size={'small'}>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell rowSpan={2} style={{'fontWeight': 'bold'}}>Максимальное
                                                количество баллов по дисциплине</TableCell>
                                            <TableCell align={'center'}
                                                       style={{'fontWeight': 'bold'}}>Норматив</TableCell>
                                            <TableCell align={'center'} style={{'fontWeight': 'bold'}}>По
                                                дисциплине</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell align={'center'} style={{'fontWeight': 'bold'}}>100</TableCell>
                                            <TableCell align={'center'} style={{'fontWeight': 'bold'}}>100</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                <Typography fontSize={'small'}>
                                                    посещение лекционных и практических занятий
                                                </Typography>
                                            </TableCell>
                                            <TableCell align={'center'}>
                                                <strong>от 8 до 20</strong>
                                            </TableCell>
                                            <TableCell align={'center'}>
                                                <TextField size={'small'}
                                                           type={'number'}
                                                           disabled
                                                           value={sumAttendanceGradeFromTo(0, copyOfThemes.length - 1)}
                                                           onChange={(event) => {
                                                               setDisciplineLectureHoursMaximum(parseInt(event.target.value, 10))
                                                           }}
                                                           sx={{width: '70px'}}/>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                <Typography fontSize={'small'}>
                                                    текущий контроль (аудиторная и самостоятельная работа)
                                                </Typography>
                                                <Typography fontSize={'smaller'} color={'gray'}>(складывается из суммы макс. баллов по требованиям по дисциплине)</Typography>
                                            </TableCell>
                                            <TableCell align={'center'}>
                                                <Stack direction={'row'} spacing={1}>
                                                    <strong>от 44 до 56</strong>
                                                </Stack>
                                            </TableCell>
                                            <TableCell align={'center'}>
                                                <TextField size={'small'}
                                                           type={'number'}
                                                           disabled
                                                           value={sumDisciplineRequirementsMaxPoints()}
                                                           onChange={(event) => {
                                                               setDisciplineAuditoriumHoursMaximum(parseInt(event.target.value, 10))
                                                           }}
                                                           sx={{width: '70px'}}/>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell style={{'fontWeight': 'bold'}}>
                                                Итого без промежуточной аттестации
                                            </TableCell>
                                            <TableCell align={'center'} style={{'fontWeight': 'bold'}}>64</TableCell>
                                            <TableCell align={'center'} style={{'fontWeight': 'bold'}}>
                                                <Typography color={parseFloat(sumAttendanceGradeFromTo(0, copyOfThemes.length - 1)) + sumDisciplineRequirementsMaxPoints() > 64 ? 'red' : 'black'}
                                                    fontWeight={'bold'}
                                                    fontSize={'medium'}>
                                                    {(parseFloat(sumAttendanceGradeFromTo(0, copyOfThemes.length - 1)) + sumDisciplineRequirementsMaxPoints()).toFixed(2)}
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell style={{'fontWeight': 'bold'}}>
                                                Дополнительные баллы по распоряжению деканата (НО! итоговое количество баллов
                                                у обучающегося не должно превысить 100)
                                            </TableCell>
                                            <TableCell align={'center'} style={{'fontWeight': 'bold'}}>0-15</TableCell>
                                            <TableCell align={'center'} style={{'fontWeight': 'bold'}}>0</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>

                            <br/>
                            <Divider/>
                            <Typography fontWeight={'bold'} align={'center'}>Максимальное количество баллов по контролю
                                посещаемости и текущему контролю успеваемости обучающегося - 64.</Typography>
                            <Typography align={'center'}>Итоговая сумма баллов, полученная обучающимся на промежуточной
                                аттестации (зачете, экзамене) и по результатам посещаемости и текущего контроля
                                успеваемости в семестре, преобразуется в пятибалльную систему оценок в соответствии с
                                порядком перевода 100-балльной оценки в 5-балльную:</Typography>
                            <Table size={'small'}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align={'right'}>
                                            <Typography fontWeight={'bold'} fontSize={'small'}>100-балльная система
                                                <br/>От - До</Typography>
                                        </TableCell>
                                        <TableCell align={'left'}><Typography fontWeight={'bold'} fontSize={'small'}>5-балльная
                                            система</Typography></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        <TableCell align={'right'}>
                                            <Stack direction={'row'} spacing={1} justifyContent={'end'}
                                                   alignItems={'center'}>
                                                {getRangeField('grade5From', '')}
                                                <strong> - </strong>
                                                {getRangeField('grade5To', '')}
                                            </Stack>
                                        </TableCell>
                                        <TableCell align={'left'}>Отлично / "зачтено"</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell align={'right'}>
                                            <Stack direction={'row'} spacing={1} justifyContent={'end'}
                                                   alignItems={'center'}>
                                                {getRangeField('grade4From', '')}
                                                <strong> - </strong>
                                                {getRangeField('grade4To', '')}
                                            </Stack>
                                        </TableCell>
                                        <TableCell align={'left'}>Хорошо / "зачтено"</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell align={'right'}>
                                            <Stack direction={'row'} spacing={1} justifyContent={'end'}
                                                   alignItems={'center'}>
                                                {getRangeField('grade3From', '')}
                                                <strong> - </strong>
                                                {getRangeField('grade3To', '')}
                                            </Stack>
                                        </TableCell>
                                        <TableCell align={'left'}>Удовлетворительно / "зачтено"</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell align={'right'}>
                                            <Stack direction={'row'} spacing={1} justifyContent={'end'}
                                                   alignItems={'center'}>
                                                {getRangeField('grade2From', '')}
                                                <strong> - </strong>
                                                {getRangeField('grade2To', '')}
                                            </Stack>
                                        </TableCell>
                                        <TableCell align={'left'}>Неудовлетворительно</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </Stack>
                    </Card>

                    <Button variant={'contained'}
                            fullWidth
                            disabled={isSaving || (!canEdit && !isAdmin)}
                            startIcon={isSaving ? <CircularProgress size={15}/> : <SaveAs/>}
                            onClick={handleSave}>Сохранить изменения</Button>
                    {!canEdit && isAdmin
                    ? <p>повторное сохранение доступно только для администратора</p>
                    : <></>}
                    <br/>
                </Stack>
            </Container>
        </MainLayout>
    );
}